import ConfirmIcon from '~/assets/icons/icon-warning-green.png';
import SuccesIcon from '~/assets/icons/icon-sucess.svg';
import PrintIcon from '~/assets/icons/printIcon.png';
import PdfPerfilHospitalar from '../../../assets/PerfilHospitalar.pdf';

// export const modalConfirm = {
//   html: `<div><div class="headerModalIndicador">
//           <img src=${ConfirmIcon} /><h2>Por favor, <span>confirme a
//           submissão dos dados.</span> </h2></div>
//           <div class="bodyModalIndicador">
//           <p>Os dados inseridos poderão ser utilizados para ajustes em
//           alguns indicadores e somente poderão ser editados uma
//           vez ao ano. <span>Deseja submetê-los?</span></p></div>
//         </div>`,
//   showCancelButton: true,
//   confirmButtonColor: '#74a50a',
//   cancelButtonColor: '',
//   confirmButtonText: 'Submeter',
//   cancelButtonText: 'Ainda não',
//   customClass: {
//     container: 'container-modal-confirm-perfil',
//     confirmButton: 'confirm-button-container-modal-confirm-perfil',
//     cancelButton: 'cancel-button-container-modal-confirm-perfil',
//   },
// };

export const modalConfirm = {
  html: `<div><div class="headerModalIndicador">
          <img src=${ConfirmIcon} /><h2>Por favor, <span>confirme a
          submissão dos dados.</span> </h2></div>
          <div class="bodyModalIndicador">
          <p>Você confirma que as informações inseridas foram atualizadas para o<b> ano atual? </b></p></div>
        </div>`,
  showCancelButton: true,
  confirmButtonColor: '#74a50a',
  cancelButtonColor: '',
  confirmButtonText: 'Sim, submeter',
  cancelButtonText: 'Ainda não',
  customClass: {
    container: 'container-modal-confirm-perfil',
    confirmButton: 'confirm-button-container-modal-confirm-perfil',
    cancelButton: 'cancel-button-container-modal-confirm-perfil',
  },
};

export const modalSuccess = {
  html: `<div>
          <div class="headerModalIndicador">
          <img src=${SuccesIcon} />
          <h2> <span> Perfil atualizado </span> com sucesso! </div>
          <div class="bodyModalIndicador">
          <p>Lembre-se de que os dados inseridos poderão ser utilizados
          para ajustes em alguns indicadores. Por isso, deverão ser
          atualizados, obrigatoriamente, uma vez ao ano. </p></div>
        </div>`,
  showCancelButton: false,
  confirmButtonColor: '#74a50a',
  cancelButtonColor: '',
  confirmButtonText: 'Ok! Obrigado!',
  customClass: {
    container: 'container-modal-switch-indicadores-confirm',
    confirmButton: 'confirm-button-switch-indicadores-confirm',
    cancelButton: 'cancel-button-switch-indicadores-confirm',
  },
};

export const modalSuccessReabertura = {
  html: `<div>
          <div class="headerModalIndicador">
          <img src=${SuccesIcon} />
          <h2> <span> Perfil reaberto </span> com sucesso! </div>
          <div class="bodyModalIndicador">
          <p>Lembre-se de que os dados inseridos poderão ser utilizados
          para ajustes em alguns indicadores. Por isso, deverão ser
          atualizados, obrigatoriamente, uma vez ao ano. </p></div>
        </div>`,
  showCancelButton: false,
  confirmButtonColor: '#74a50a',
  cancelButtonColor: '',
  confirmButtonText: 'Ok! Obrigado!',
  customClass: {
    container: 'container-modal-switch-indicadores-confirm',
    confirmButton: 'confirm-button-switch-indicadores-confirm',
    cancelButton: 'cancel-button-switch-indicadores-confirm',
  },
};

export const modalValidade = {
  html: `<div>
          <div class="headerModalIndicador">
          <img src=${ConfirmIcon} />
          <h2>  Atente-se a  <span>validade
          deste formulário! </span> </h2>
          </div>
          <div class="bodyModalIndicador">
            <p>
            Os dados inseridos poderão ser utilizados para ajustes em alguns indicadores e somente poderão ser editados uma vez ao ano. Deseja prosseguir?
            </p>
          </div>
        </div>`,
  showCancelButton: true,
  confirmButtonColor: '#74a50a',
  cancelButtonColor: '',
  confirmButtonText: 'Sim',
  cancelButtonText: 'Imprimir modelo',
  customClass: {
    container: 'container-modal-validade-perfil',
    confirmButton: 'confirm-button-validade-perfil',
  },
};

export const modalPdf = {
  html: `<div>
          <div class="headerModalIndicador">
           <img src=${PrintIcon} />
          <h2>  Imprima um modelo </span> </h2>
          
          </div>

          <span style="font-size: 12px;">Clique no ícone da impressora para imprimir uma cópia.</span>
          <br />
         <div style="padding-top: 20px">
          <object
            id="PdfPerfilHospitalar"
            type="application/pdf"
            data=${PdfPerfilHospitalar}
            width="950"
            height="550"
          />
         </div>

     
        </div>`,
  width: 1000,
  showCancelButton: true,
  showConfirmButton: false,
  confirmButtonColor: '#74a50a',
  cancelButtonColor: '',
  confirmButtonText: 'Sim',
  cancelButtonText: 'Fechar',
  customClass: {
    container: 'container-modal-validade-perfil',
  },
};
